module.exports = __webpack_public_path__ + "static/media/Exercise Therapy Video Screenshot.9c42b2c7.png";